/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from '../helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function EditAction({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes/Notes/Content/Note/Read/EditAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentNoteValueData = fromData.useDataValue({ viewPath,
context: 'appointment_note',
})
let eventAppointmentValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment',
})
let aggregateData = fromHelpers.isEditable(appointmentNoteValueData, eventAppointmentValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}